import script from "./clientSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./clientSwiper.vue?vue&type=script&setup=true&lang=js"

import "./clientSwiper.vue?vue&type=style&index=0&id=d50e5e34&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d50e5e34"]])

export default __exports__